"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clientAuth = require("@devsta/client-auth");

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _ListItem = _interopRequireDefault(require("./ListItem"));

var _CardItem = _interopRequireDefault(require("./CardItem"));

var _filterOptions = require("../constants/filterOptions");

var _filterTypes = require("../constants/filterTypes");

require("../styles/_organisations.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RESERVED_SEGMENTS = ['develop', 'staging', 'app'];

var getAliasUrl = function getAliasUrl(alias) {
  var subdomainSegments = window.location.hostname.split('.');

  if (RESERVED_SEGMENTS.includes(subdomainSegments[0])) {
    return "".concat(alias, ".").concat(window.location.hostname);
  }

  return "".concat(alias, ".").concat(subdomainSegments.slice(1).join('.'));
};

var Organisations = /*#__PURE__*/function (_Component) {
  _inherits(Organisations, _Component);

  function Organisations() {
    var _this;

    _classCallCheck(this, Organisations);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Organisations).call(this));

    _defineProperty(_assertThisInitialized(_this), "onClick", (0, _lodash.default)(function (organisationId) {
      return function () {
        var history = _this.props.history;
        history.push("organisations/edit/".concat(organisationId, "#1"));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getViewableOrganisations", (0, _memoizeOne.default)(function (organisations) {
      return organisations.filter(function (singleOrganisation) {
        return singleOrganisation.name !== 'Shootsta';
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _lodash.default)(function (organisation) {
      var actionOptions = [{
        action: function action() {
          return _this.loginToOrg(organisation.alias);
        },
        label: "Go to ".concat(organisation.name),
        isRed: false,
        requiredPermission: 'MANAGE_CUSTOMERS'
      }];
      return actionOptions;
    }));

    _defineProperty(_assertThisInitialized(_this), "loginToOrg", function (alias) {
      var _credentials$get = _clientAuth.credentials.get(),
          token = _credentials$get.token,
          user = _credentials$get.user;

      var domain = getAliasUrl(alias);
      var encodedData = {
        token: token,
        user: user,
        targetURL: '/organisation'
      };
      var base64 = btoa(JSON.stringify(encodedData));
      window.open("//".concat(domain, "?ghost=").concat(base64));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCardItem", function (organisation) {
      var hasUpdatePermission = _this.state.hasUpdatePermission;
      return _react.default.createElement(_CardItem.default, {
        key: organisation.organisationId,
        organisation: organisation,
        onClick: _this.onClick(organisation.organisationId),
        hasUpdatePermission: hasUpdatePermission,
        actionOptions: _this.getActionOptions(organisation)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (organisation) {
      var containerSize = _this.props.containerSize;
      return _react.default.createElement(_ListItem.default, {
        key: organisation.organisationId,
        containerSize: containerSize,
        organisation: organisation,
        onClick: _this.onClick(organisation.organisationId),
        actionOptions: _this.getActionOptions(organisation)
      });
    });

    _this.state = {
      hasUpdatePermission: false
    };
    return _this;
  }

  _createClass(Organisations, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, apolloClient, getOrganisations, orgPermissions, _ref, data, error, filteredOrganisations, hasUpdatePermission, orgsWithImages;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, apolloClient = _this$props.apolloClient, getOrganisations = _this$props.getOrganisations, orgPermissions = _this$props.orgPermissions;
                _context.next = 3;
                return getOrganisations();

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                error = _ref.error;

                if (!(!data || error)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", void this.setState({
                  error: error || 'Error'
                }));

              case 8:
                filteredOrganisations = this.getViewableOrganisations(data.getOrganisations);
                hasUpdatePermission = (0, _commonReact.hasPermission)('MANAGE_CUSTOMERS', orgPermissions);
                _context.prev = 10;
                _context.next = 13;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apolloClient,
                  dataArray: filteredOrganisations,
                  substitutedKeys: ['imageUrl', {
                    key: 'defaultUser',
                    subKeys: ['imageUrl']
                  }]
                });

              case 13:
                orgsWithImages = _context.sent;
                this.setState({
                  organisations: orgsWithImages,
                  hasUpdatePermission: hasUpdatePermission
                });
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](10);
                this.setState({
                  error: _context.t0.message
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 17]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _ref2;

      var _this$props2 = this.props,
          history = _this$props2.history,
          containerWidth = _this$props2.containerSize.width;
      var _this$state = this.state,
          organisations = _this$state.organisations,
          error = _this$state.error,
          hasUpdatePermission = _this$state.hasUpdatePermission;
      var medium = _vars.NUMERIC_MEDIA_SIZES.medium,
          small = _vars.NUMERIC_MEDIA_SIZES.small;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)('organisations', 'page', {
          'organisations--medium': containerWidth < medium && containerWidth > small,
          'organisations--small': containerWidth < small
        })
      }, _react.default.createElement(_uiKit.PageHeader, {
        title: "Manage Organisations",
        subtitle: "Shootsta",
        actionBtnText: hasUpdatePermission ? 'Create New Organisation' : void 0,
        actionBtnOnClick: function actionBtnOnClick() {
          return history.push('organisations/edit/new');
        }
      }), _react.default.createElement("div", {
        className: "organisations__content page__content"
      }, _react.default.createElement(_uiKit.List, {
        loading: !organisations,
        history: history,
        renderCardItem: this.renderCardItem,
        renderListItem: this.renderListItem,
        emptyDataText: "Oops.. there are no Organisation Accounts found on the HUB",
        data: organisations,
        listKey: "organisationId",
        filters: (_ref2 = {}, _defineProperty(_ref2, _filterTypes.ORGANISATION_TYPE, _filterOptions.ORGANISATION_TYPE_OPTIONS), _defineProperty(_ref2, _filterTypes.WHOS_ORGANISATIONS, _filterOptions.WHOS_ORGANISATIONS_OPTIONS), _ref2)
      })));
    }
  }]);

  return Organisations;
}(_react.Component);

exports.default = Organisations;